import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../Components/BackButton";
import { Success, Error } from "../../Components/Modal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { categorySchema } from "../../Schema/generalSchema";
import { useMutation } from "react-query";
import { createCategory } from "../../Services/Category";
import CategoryForm from "./Components/CategoryForm";
import "../CMSManagement/CMSManagement.css";
import "../../styles/PremiumCardPages.css";

export default function AddCategory() {
    const navigate = useNavigate();
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);

    const formMethods = useForm({
        resolver: yupResolver(categorySchema),
        defaultValues: {
            status: "true",
            isFragile: false,
            isHeavy: false,
        },
    });

    const { register, handleSubmit, formState: { errors }, control, setValue, watch } = formMethods;

    const { mutate, isLoading } = useMutation(createCategory, {
        onSuccess: (res) => {
            Success("New Category Created", res.data?.message || "Logistics category has been added successfully.");
            navigate("/category-management");
        },
        onError: (err) => {
            Error(err?.response?.data?.message || "Failed to create category. Please verify your connection.");
        },
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append("typeName", "categoryImage");
        Object.keys(data).forEach((key) => formData.append(key, data[key]));
        if (image) formData.append("categoryImage", image);
        mutate(formData);
    };

    return (
        <div className="app-content content pform-page">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="add-category">
                        <div className="user-details-wrapper">
                            <div className="pform-page-header">
                                <div className="pform-page-header__row">
                                    <BackButton />
                                    <h1 className="pform-page-header__title">New Category Profile</h1>
                                </div>
                                <p className="pform-page-header__subtitle">
                                    Add a logistics category with image, weight, and handling rules
                                </p>
                            </div>

                            <div className="pform-shell">
                                <CategoryForm
                                    register={register}
                                    handleSubmit={handleSubmit}
                                    errors={errors}
                                    control={control}
                                    onSubmit={onSubmit}
                                    isLoading={isLoading}
                                    preview={preview}
                                    handleImageChange={handleImageChange}
                                    isFragile={watch("isFragile")}
                                    isHeavy={watch("isHeavy")}
                                    setValue={setValue}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
